// Push each package line onto the shopper's existing cart as its own product.
// The cart watcher in front/src/helpers/cart.js saves the whole cart, including
// its 403 recovery. Nothing here calls BigCommerce or creates a bundle SKU.

const MAX_QTY = 99

export function packagePayload(lines) {
	return (lines || []).map((line) => ({
		productId: Number(line.bcProductId),
		variantId: Number(line.bcVariantId),
		sku: line.sku,
		quantity: line.qty,
	}))
}

export function addPackageToCart(cart, lines) {
	if (!cart || typeof cart !== 'object') return { ok: false, code: 'no-cart' }
	if (!Array.isArray(lines) || lines.length === 0) return { ok: false, code: 'empty' }

	const normalized = []
	for (const line of lines) {
		const quantity = line?.qty ?? line?.quantity
		if (!line?.product?.id || !line?.variant?.id) {
			return { ok: false, code: 'unresolved', name: line?.name || 'An item' }
		}
		if (!Number.isInteger(quantity) || quantity < 1 || quantity > MAX_QTY) {
			return { ok: false, code: 'quantity', name: line?.name || 'An item' }
		}
		if (line.outOfStock) return { ok: false, code: 'out-of-stock', name: line?.name || 'An item' }
		normalized.push({
			item: line.product,
			variant: line.variant,
			quantity,
			payload: {
				productId: Number(line.bcProductId),
				variantId: Number(line.bcVariantId),
				sku: line.sku,
				quantity,
			},
		})
	}

	if (!Array.isArray(cart.cartItems)) cart.cartItems = []
	for (const line of normalized) {
		const existing = cart.cartItems.find((item) => item?.variant?.id === line.variant.id && (item?.item?.id || item?.item) === line.item.id)
		if (existing) existing.quantity += line.quantity
		else cart.cartItems.push({ item: line.item, variant: line.variant, quantity: line.quantity })
	}
	return { ok: true, added: normalized.map((line) => line.payload) }
}

export function packageBlockReason(view, flags = {}) {
	if (!view || view.empty) return ''
	if (flags.loading) return 'Checking live prices and stock…'
	if (!flags.cartReady) return 'Your bag isn’t ready yet. Refresh the page, then add the package.'
	if (!flags.catalogLoaded) return 'Live prices didn’t load, so this package can’t be added yet. Refresh the page and try again.'
	const blocked = view.lines.find((line) => line.outOfStock || !line.product?.id || !line.variant?.id)
	if (!blocked) return ''
	if (blocked.outOfStock) return `${blocked.name} is out of stock. Choose another option or remove it.`
	return `We couldn’t match ${blocked.name} to a store product. Remove it, or refresh the page.`
}
